@if (columns.includes('select')) {
  <div class="selection-bar">
    @if (selectedIds.size > 0) {
      <button (click)="selectedIds.clear()" mat-stroked-button>Auswahl aufheben</button>
    } @else {
      <span class="gray">Wählen Sie Einträge aus, um sie einer Sammelmappe hinzuzufügen.</span>
    }
    <span class="selection-actions">
      @if (selectedIds.size > 0) {
        <span>{{ selectedIds.size }} {{ selectedIds.size === 1 ? 'Eintrag' : 'Einträge' }} ausgewählt</span>
      }
      <button (click)="addSelectionToFolder()" [disabled]="selectedIds.size === 0" color="primary" mat-flat-button>
        <mat-icon>create_new_folder</mat-icon>
        Zu Sammelmappe hinzufügen
      </button>
    </span>
  </div>
}
<div class="custom-scrollbar" style="overflow-x: auto;">
  <table [dataSource]="data" class="w100" mat-table matSort matSortActive="created" matSortDirection="desc"
         matSortDisableClear multiTemplateDataRows>

    <!-------------------- shared columns -------------------->

    <!-- selection for Sammelmappen -->
    <ng-container matColumnDef="select">
      <th *matHeaderCellDef class="select-cell" mat-header-cell>
        <mat-checkbox (change)="togglePage($event.checked)" [checked]="isPageSelected()"
                      [indeterminate]="isPagePartlySelected()" aria-label="Alle Einträge der Seite auswählen"
                      matTooltip="Alle Einträge der Seite auswählen" matTooltipShowDelay="1000"></mat-checkbox>
      </th>
      <td *matCellDef="let element" (click)="$event.stopPropagation()" class="select-cell" mat-cell>
        <mat-checkbox (change)="toggleSelection(element.id, $event.checked)" [checked]="selectedIds.has(element.id)"
                      aria-label="Eintrag für Sammelmappe auswählen"></mat-checkbox>
      </td>
    </ng-container>

    <!-- prod Column -->
    <ng-container matColumnDef="productive">
      <th *matHeaderCellDef disableClear mat-header-cell mat-sort-header> prod.</th>
      <td *matCellDef="let element" mat-cell>
              <span [class.table-all]="element.productive==='NONE'"
                    [class.table-a0]="element.productive==='A0'"
                    [class.table-a1]="element.productive==='A1'"
                    [class.table-a2]="element.productive==='A2'"
                    [class.table-b1]="element.productive==='B1'"
                    [class.table-b2]="element.productive==='B2'"
                    [class.table-c1]="element.productive==='C1'"
                    [class.table-c2]="element.productive==='C2'">
                {{ element.productive === "NONE" ? "Offen" : element.productive }}
              </span>
      </td>
    </ng-container>

    <!-- rez Column -->
    <ng-container matColumnDef="receptive">
      <th *matHeaderCellDef disableClear mat-header-cell mat-sort-header> rez.</th>
      <td *matCellDef="let element" mat-cell>
              <span [class.table-all]="element.receptive==='NONE'"
                    [class.table-a0]="element.receptive==='A0'"
                    [class.table-a1]="element.receptive==='A1'"
                    [class.table-a2]="element.receptive==='A2'"
                    [class.table-b1]="element.receptive==='B1'"
                    [class.table-b2]="element.receptive==='B2'"
                    [class.table-c1]="element.receptive==='C1'"
                    [class.table-c2]="element.receptive==='C2'">{{ element.receptive === "NONE" ? "Offen" : element.receptive }}</span></td>
    </ng-container>

    <!-- Name Column -->
    <ng-container id="word-name-col" matColumnDef="name">
      <th *matHeaderCellDef disableClear mat-header-cell mat-sort-header> Wort</th>
      <td *matCellDef="let element" mat-cell>
        <span *ngIf="expandedElement === element && isAuthorized; else normal" class="bold"
              style="font-size: 1.1em">{{ element.name }}</span>
        <ng-template #normal>{{ element.name }}</ng-template>
      </td>
    </ng-container>

    <!-- Eintrag Column(same as Name but with different header) -->
    <ng-container id="word-entry-col" matColumnDef="entry">
      <th *matHeaderCellDef disableClear mat-header-cell mat-sort-header> Eintrag</th>
      <td *matCellDef="let element" mat-cell>
        <span *ngIf="expandedElement === element && isAuthorized; else normal" class="bold"
              style="font-size: 1.1em">{{ element.name }}</span>
        <ng-template #normal>{{ element.name }}</ng-template>
      </td>
    </ng-container>

    <!-- Bezugswort Column -->
    <!-- (no "Bezugswort" anymore -> Verweise!)
    <ng-container matColumnDef="relatedVocab">
      <th *matHeaderCellDef mat-header-cell> Bezugswort</th>
      <td *matCellDef="let element" mat-cell><span
        *ngIf="element.relatedVocab[0]!==undefined"> {{element.relatedVocab[0].name}}</span></td>
    </ng-container>
    -->

    <!-- Variante Column -->
    <ng-container matColumnDef="country">
      <th *matHeaderCellDef mat-header-cell> Variante</th>
      <td *matCellDef="let element" mat-cell> {{ getCountryDetails(element.country) }}</td>
    </ng-container>

    <!-- Thema Column-->
    <ng-container matColumnDef="category">
      <th *matHeaderCellDef disableClear mat-header-cell mat-sort-header> Thema</th>
      <td *matCellDef="let element" mat-cell>{{ element.categoryName }}</td>
    </ng-container>

    <!-- Details Column-->
    <ng-container matColumnDef="details">
      <th *matHeaderCellDef mat-header-cell style="text-align: center !important;"> Details</th>
      <td *matCellDef="let element" mat-cell style="text-align: center !important;">
        @if (isAuthorized) {
          <button mat-icon-button aria-label="expand row"
                  (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
            @if (expandedElement !== element) {
              <mat-icon>keyboard_arrow_down</mat-icon>
            } @else {
              <mat-icon>keyboard_arrow_up</mat-icon>
            }
          </button>
        } @else {
          <button mat-icon-button (click)="openRegisterPopup()">
            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>
        }
      </td>

    </ng-container>

    <!-------------------- grammar columns -------------------->
    <ng-container id="pattern-example-col" matColumnDef="example">
      <th *matHeaderCellDef disableClear mat-header-cell mat-sort-header> Beispiel</th>
      <td *matCellDef="let element" mat-cell>{{ element.example }}</td>
    </ng-container>

    <!-------------------- text type columns -------------------->
    <ng-container id="text-type-modes" matColumnDef="modes">
      <th *matHeaderCellDef disableClear mat-header-cell mat-sort-header> Fertigkeit</th>
      <td *matCellDef="let element" mat-cell>{{ showModes(element.modes) }}</td>
    </ng-container>

    <ng-container id="text-type-domains" matColumnDef="domains">
      <th *matHeaderCellDef disableClear mat-header-cell mat-sort-header> Bereich</th>
      <td *matCellDef="let element" mat-cell>{{ showDomains(element.domains) }}</td>
    </ng-container>

    <ng-container id="text-type-interactions" matColumnDef="interactions">
      <th *matHeaderCellDef disableClear mat-header-cell mat-sort-header> Interaktion</th>
      <td *matCellDef="let element" mat-cell>{{ showInteractions(element.interactions) }}</td>
    </ng-container>


    <!------------------ Expanded Content Column ------------------
    The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="columns.length">
        <div [@detailExpand]="element === expandedElement ? 'expanded' : 'done'">
          <app-entry-details *ngIf="element === expandedElement && isAuthorized" [id]="element.id" [service]="service"></app-entry-details>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th *matHeaderCellDef mat-header-cell> Bearbeiten</th>
      <td *matCellDef="let element" mat-cell style="width:128px">
              <span>
                <button
                  (click)="editEntry(element.id)"
                  color="primary"
                  mat-icon-button
                  matTooltip="Wort bearbeiten"
                  matTooltipShowDelay="1000"
                  matTooltipPosition="left"
                  matTooltipHideDelay="200">
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  (click)="deleteEntry(element)"
                  color="warn"
                  mat-icon-button
                  matTooltip="Wort löschen"
                  matTooltipShowDelay="1000"
                  matTooltipPosition="right"
                  matTooltipHideDelay="200">
                  <mat-icon>delete</mat-icon>
                </button>
              </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let element; columns: columns;" class="element-row"
        [class.expanded-row]="expandedElement === element"
        (click)="expandedElement = expandedElement === element ? null : element">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>

    <!-- Row shown when there is no matching data. -->
    @if (!isLoadingResults) {
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="5">
          <div class="pad16 no-data-row">
            <span class="bigger-font">Keine Suchergebnisse gefunden </span>
          </div>
        </td>
      </tr>
    }

  </table>
  @if (isLoadingResults) {
    <div class="center-content pad16">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  }
  <mat-paginator [length]="resultsLength" [pageSizeOptions]="[ 25, 50, 100]" [pageSize]="25"
                 showFirstLastButtons class="paginator"></mat-paginator>
</div>
